import type { WorldRegion } from "../../../config/worldRegionsConfig";
import type { DeepPartialAndUndefinable } from "../../types";
import type { ApiWarningLayerData } from "./types/api";
import type { WarningLayerData } from "./types/data";

export function isValidWarningLayerDataResponse(
    response: DeepPartialAndUndefinable<ApiWarningLayerData>,
): response is ApiWarningLayerData {
    return (
        response.tilesBaseUrl !== undefined && response.tilesMVT !== undefined
    );
}

export function mapApiWarningLayerDataToWarningLayerData(
    apiData: ApiWarningLayerData,
    worldRegion: WorldRegion,
): WarningLayerData {
    return {
        run: new Date(apiData.runDate),
        bounds: [
            apiData.bounds.sw.lng,
            apiData.bounds.sw.lat,
            apiData.bounds.ne.lng,
            apiData.bounds.ne.lat,
        ],
        tilesBaseUrl: apiData.tilesBaseUrl.startsWith("https://")
            ? apiData.tilesBaseUrl
            : `https://${apiData.tilesBaseUrl}`,
        tilesZXYUrl: apiData.tilesMVT,
        worldRegion,
        warningDetailsUrlTemplate: apiData.warningDetailsUrlTemplate,
        warningCellDetailsUrlTemplate: apiData.warncellDetailsUrlTemplate,
        debug: {
            source: "unspecified",
        },
    };
}
